var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 42.797,
    viewBox: "0 0 50 42.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "store-default",
    d: "M51.961,19.692,48.394,5.427A1.737,1.737,0,0,0,46.611,4H7.38A1.737,1.737,0,0,0,5.6,5.427L2.031,19.692a1.819,1.819,0,0,0,.357,1.6,1.479,1.479,0,0,0,1.427.535H5.6V46.8H41.262a7.154,7.154,0,0,0,7.133-7.133V21.832h1.783a1.622,1.622,0,0,0,1.427-.713A2.144,2.144,0,0,0,51.961,19.692Zm-4.1-1.427H39.478V7.566h5.706Zm-19.08,0V7.566h7.133v10.7Zm-10.7,0V7.566h7.133v10.7ZM8.807,7.566h5.706v10.7H6.132ZM23.429,43.231V30.748h7.133V43.231Zm21.4-3.566a3.577,3.577,0,0,1-3.566,3.566H34.129V30.748a3.577,3.577,0,0,0-3.566-3.566H23.429a3.577,3.577,0,0,0-3.566,3.566V43.231H9.164v-21.4H44.828Z",
    transform: "translate(-1.961 -4)",
    fill: "#00c1d4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreDefault);
export default __webpack_public_path__ + "static/media/store-default.d4b4bd849c3c7ede166bed7016c3e5c0.svg";
export { ForwardRef as ReactComponent };